// extracted by mini-css-extract-plugin
module.exports = {"container":"Need2FA_container__Bfcoh","formContainer":"Need2FA_formContainer__RaZE0","back":"Need2FA_back__p3oKy","form":"Need2FA_form__NGlpy"};